export default __webpack_public_path__ + "static/media/107879542_3019883888106923_2575705782430388088_n@2x.ffb54d02.png";